core.directive('edmFixed', ['$parse',
    function($parse) {
        var definition = {
            restrict: 'A',
            link: function($scope, element, attr) {

                var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
                var rightBar = $('#right-bar');
                var patientList = $('#patient-list');
                var patientListScroll = $('#patient-list-scroll');
                var searchPatient = $('#search-patient');

                var listHeight = viewportHeight - searchPatient.outerHeight(true);
                var rightBarHeight = viewportHeight;

                rightBar.css('height', rightBarHeight + 'px');
                patientList.css('height', listHeight + 'px');
                patientListScroll.css('height', listHeight + 'px');



                var initRightBarTop = rightBar.offset().top;
                $(window).scroll(function () {
                    var mainHeight = $('#main').height();
                    var difference = $(window).scrollTop() - initRightBarTop;
                    if(difference > 0) {
                        if(difference + rightBarHeight > mainHeight) {
                            var a = mainHeight - rightBarHeight;
                            $('#right-bar').css('top', a+'px');
                        } else {
                            $('#right-bar').css('top', difference + 'px');
                        }
                    } else {
                        $('#right-bar').css('top', '0px');
                    }

                });



            }
        };

        return definition;
    }
]);